/** Default rows per page for tables across the dashboard */
export const TABLE_PAGE_SIZE = 20;
